export default __webpack_public_path__ + "e681cb4de303c6a6ebd2799319873bdf.jpg";